module.exports = __webpack_public_path__ + "static/media/enable.ce25a5a6.png";